import {useListCompanyAccountsQuery} from "../../apis/companiesApi";
import {useMemo} from "react";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { useIsParentDisabled } from "hooks/departmentHooks";

const OrganizationalIndexTreeCard = ({department}) => {
    const navigate = useNavigate();
    const {data: userProfile} = useUserProfileQuery();
    const {data: companyUsers, isFetching: isFetchingCompanyUsers} = useListCompanyAccountsQuery();
    const {disabled, isFetching: isFetchingParentDisabled} = useIsParentDisabled(department?.id);

    const departmentHead = useMemo(() => {
        if(isFetchingCompanyUsers) return "";
        const user = companyUsers.find(user => user.id === department?.departmentHead);

        return user ? (user?.registered ? `${user?.firstName} ${user?.lastName}` : user?.email) : "-";
    }, [companyUsers, isFetchingCompanyUsers, department]);

    const canEditHierarchy = ['CompanyOwner'].includes(userProfile?.company?.role);
    return (
        <div className={`organizational-index-tree-card ${disabled || isFetchingParentDisabled? "disabled" : ""}`}>
            <div className="department-name">{department.name}</div>
            <div className="department-head">{departmentHead}</div>
            <div className="department-title">{department.title}</div>
            <div className="department-button-panel">
                {!canEditHierarchy && <>
                    <Button icon="pi pi-eye" className="p-button-rounded p-button-outlined" aria-label="View" onClick={() => navigate(`/company-admin/organizational-index/edit/${department.id}`)} />
                </>}
                {canEditHierarchy && <>
                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-outlined" aria-label="Edit" onClick={() => navigate(`/company-admin/organizational-index/edit/${department.id}`)} />
                    <Button icon="pi pi-plus" className="p-button-rounded p-button-outlined" aria-label="New" onClick={() => navigate(`/company-admin/organizational-index/create/${department.id}/new`)} />
                </>}
            </div>
        </div>)
}

export default  OrganizationalIndexTreeCard;
